import * as Sentry from '@sentry/react'

// Vite inlines import.meta.env at build time. The web tsconfig also compiles the
// shared @besiktning/ui source, which relies on import.meta.env staying untyped
// (it has its own @ts-expect-error guards), so we read env via a local cast here
// instead of a global vite/client reference that would leak into that package.
const env =
  (import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {}

// DSN comes from VITE_SENTRY_DSN. When unset, initSentry is a no-op and every
// Sentry.* call does nothing — so local dev stays silent unless a DSN is set.
const dsn = env.VITE_SENTRY_DSN

export function initSentry() {
  if (!dsn) return

  Sentry.init({
    dsn,
    // production / preview / development — falls back to Vite's mode.
    environment: env.VITE_SENTRY_ENV ?? env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    // Performance tracing: sample 20% of transactions in prod. Override with
    // VITE_SENTRY_TRACES_RATE.
    tracesSampleRate: Number(env.VITE_SENTRY_TRACES_RATE ?? 0.2),
    // No PII (IP/user) unless a request explicitly attaches it.
    sendDefaultPii: false,
  })
}

// Tag events with the white-label tenant. Called once the brand resolves so a
// single Sentry project can separate SE vs UAE (and future clients).
export function setSentryTenant(tenant: string) {
  if (!dsn) return
  Sentry.setTag('tenant', tenant)
}
